import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/** Coordinates boot splash dismiss with the first real screen (login). */
@Injectable({ providedIn: 'root' })
export class BootSplashService {
  private readonly loginReady$ = new BehaviorSubject<boolean>(false);

  markLoginReady(): void {
    if (!this.loginReady$.value) {
      this.loginReady$.next(true);
    }
  }

  whenLoginReady(): Promise<void> {
    if (this.loginReady$.value) {
      return Promise.resolve();
    }
    return new Promise((resolve) => {
      const sub = this.loginReady$.subscribe((ready) => {
        if (ready) {
          sub.unsubscribe();
          resolve();
        }
      });
    });
  }
}
